import React from 'react';

interface Alert {
  productId: string;
  productName: string;
  currentStock: number;
  lowThreshold: number;
  severity: 'info' | 'warning' | 'critical';
}

interface StockAlertsBadgeProps {
  critical: Alert[];
  warning: Alert[];
}

export function StockAlertsBadge({ critical, warning }: StockAlertsBadgeProps) {
  const totalAlerts = critical.length + warning.length;

  if (totalAlerts === 0) {
    return (
      <div className="bg-green-50 border-l-4 border-green-400 p-4 rounded">
        <div className="flex items-center">
          <span className="text-green-600 font-medium">✅ All stock levels OK</span>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {critical.length > 0 && (
        <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
          <div className="font-semibold text-red-800 mb-2">
            🚨 Out of Stock ({critical.length})
          </div>
          <div className="space-y-1">
            {critical.map((item) => (
              <div key={item.productId} className="text-sm text-red-700">
                {item.productName}
              </div>
            ))}
          </div>
        </div>
      )}

      {warning.length > 0 && (
        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
          <div className="font-semibold text-yellow-800 mb-2">
            ⚠️ Low Stock ({warning.length})
          </div>
          <div className="space-y-1">
            {warning.map((item) => (
              <div key={item.productId} className="text-sm text-yellow-700">
                {item.productName}: {item.currentStock}/{item.lowThreshold}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
